// import external dependencies
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// remove last blue tick marker
$(function () {
  let breakdownContainer = $('.c-block--technology-breakdown');
  let findContainer = $(breakdownContainer).find('.l-container').find('.technology-breakdown-context').last();
  let lastContainer = $(findContainer).find('.context-image');
  let removeElement = $(lastContainer).addClass('no-before');
  console.log(removeElement);  

});

// replace (REQUIRED) text with asterisk
$('.gfield_required_custom').text("*");


// WEBPACK FOOTER //
// ./scripts/main.js